import { DayPicker } from 'react-day-picker';
import styled from 'styled-components';

const hex2rgb = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return [r, g, b];
};

export const StyledWrapper = styled.div`
  padding: 0.25rem;
`;

export const StyledNavContainer = styled.div`
  margin: 1.5rem 0 0;

  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

export const StyledSubmitBtnContainer = styled.div`
  width: 100%;

  @media screen and (min-width: 768px) {
    width: auto;
  }
`;

export const StyledCancelBtnContainer = styled.div`
  padding: 1rem 0 0;
  display: flex;
  justify-content: center;

  @media screen and (min-width: 768px) {
    padding: 0 1rem;
    justify-content: start;
  }
`;

export const StyledCalendarContainer = styled.div`
  margin: 1.5rem 0 0;

  @media screen and (min-width: 768px) {
    display: grid;
    column-gap: 3.75rem;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
`;

export const StyledTimeSelect = styled.div`
  @media screen and (min-width: 768px) {
    display: flex;
    width: 50%;
  }
`;

export const StyledDayPicker = styled(DayPicker)<{
  retailerTheme?: { daySelectedColor?: string; dayDisabledColor?: string };
}>`
  --rdp-cell-size: 2rem;

  margin-bottom: 1.5rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 0;
  }

  .rdp-months,
  .rdp-month {
    width: 100%;
  }

  .rdp-caption {
    margin: 0 0 0.75rem;
  }

  .rdp-caption_label {
    padding: 0;
    border: 0;
    margin: 0;
    font-size: 1.125rem;
  }

  .rdp-table {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  .rdp-head {
    display: block;
  }

  .rdp-head_cell {
    width: var(--rdp-cell-size);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
  }

  .rdp-tbody {
    display: block;
  }

  .rdp-head_row,
  .rdp-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0.5rem 0;
  }

  .rdp-button:focus {
    color: ${(props) => props.retailerTheme?.daySelectedColor};
    border: 0;
  }

  .rdp-button:hover {
    background: rgba(
      ${(props) =>
        hex2rgb(props.retailerTheme?.daySelectedColor ?? '#000000').join(',')},
      0.1
    );
    color: ${(props) => props.retailerTheme?.daySelectedColor};
  }

  .rdp-day {
    display: inline-block;
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 0.875rem;
  }

  .rdp-day_selected {
    background: ${(props) => props.retailerTheme?.daySelectedColor};
    color: white;
  }

  .rdp-day_selected:hover:not([aria-disabled='true']) {
    background: ${(props) => props.retailerTheme?.daySelectedColor};
    color: white;
  }

  .rdp-day_selected:focus:not([aria-disabled='true']) {
    background: ${(props) => props.retailerTheme?.daySelectedColor};
    border: 0;
    color: white;
  }

  .rdp-day_disabled {
    background: #ccc;
    opacity: 1;
    color: white;
  }
`;

export const StyledNoTimeSelectedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const StyledScheduledContainer = styled.div`
  margin-top: 2rem;
  display: grid;
  grid-template-rows: auto 0.0625rem auto 0.0625rem auto;
  row-gap: 1.5rem;

  @media screen and (min-width: 768px) {
    grid-template-rows: 1fr;
    row-gap: 0;
    grid-template-columns: 1fr 0.0625rem 1fr 0.0625rem 1fr;
    column-gap: 1.5rem;
  }
`;

export const StyledScheduledColumn = styled.div`
  margin: 0 0 -1rem;

  @media screen and (min-width: 768px) {
    margin: 0;
  }
`;

export const StyledColumnDivider = styled.hr`
  background: rgb(224, 224, 224);
  width: 100%;
  height: 0.0625rem;
  margin: 0;
  padding: 0;
  border: 0;

  @media screen and (min-width: 768px) {
    width: 0.0625rem;
    height: 100%;
  }
`;

export const StyledScheduledInfoContainer = styled.div`
  width: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

export const StyledDeliveryInstructionsContainer = styled.div`
  margin: 0 0 1rem;

  @media screen and (min-width: 768px) {
    margin: 0;
  }
`;

export const StyledScheduledInfoWrapper = styled.div`
  flex-grow: 1;
`;

export const StyledScheduledInfoGrid = styled.div`
  display: grid;
  grid-template-rows: auto 0.0625rem auto;
  row-gap: 1.5rem;

  @media screen and (min-width: 768px) {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 0.0625rem 2fr;
    column-gap: 1.5rem;
    row-gap: 0;
    margin-top: 0.625rem;
  }
`;

export const StyledRescheduleLink = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
  }
`;

export const StyledRescheduleMobileLink = styled.div`
  display: block;
  margin: 0 0 1rem;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const StyledMainSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3rem;
`;

export const StyledSecondarySpinnerContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 1rem;

  @media screen and (min-width: 768px) {
    display: block;
    width: auto;
    margin-top: 0;
    margin-left: 0.625rem;
  }
`;
